// extracted by mini-css-extract-plugin
module.exports = {"component":"travelportal-campaign_component__hmMa0"};